/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{getEasingForSegment as t}from"../../../easing/utils/get-easing-for-segment.js";import{removeItem as o}from"../../../utils/array.js";import{mix as e}from"../../../utils/mix.js";function i(t,e,i){for(let r=0;r<t.length;r++){const s=t[r];s.at>e&&s.at<i&&(o(t,s),r--)}}function r(o,r,s,n,a,f){i(o,a,f);for(let i=0;i<r.length;i++)o.push({value:r[i],at:e(a,f,n[i]),easing:t(s,i)})}export{r as addKeyframes,i as eraseKeyframes};
//# sourceMappingURL=edit.js.map
